import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

import { EnclosureTypesNamesConstants } from '../../constants/enclosure-types-names.constants';

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: 'app-ui-product-range-card-name',
    templateUrl: './product-range-card-name.component.html',
    styleUrl: './product-range-card-name.component.scss',
    standalone: false
})
export class ProductRangeCardNameComponent {
  @Input() description: string;
  @Input() name: string;
  enclosureTypeConstants = EnclosureTypesNamesConstants;
}
